import React, { createRef, useContext, useEffect } from 'react';
import { TextBoxLatest } from '../../common/TextBoxLatest/TextBoxLatest';
import { FormHelperText } from '@mui/material';
import { iWebFormField } from '../schema';
import { FieldsContext } from '../WebFormWorkspace';

export const WebFormInputBox = (props: { fieldConfig: iWebFormField, value?: any,editable?:any,type?: string, enableDateAutoPopup?: boolean,idNamespace?: string }) => {
    const { fieldPlaceholder, fieldType, fieldDescription, fieldLabel, isMandatory, id } = props?.fieldConfig;
    const ref: any = createRef();
    const { errors } = useContext(FieldsContext);
    const errorMsg = errors?.[id];
    const [, forceUpdate] = React.useReducer(x => x + 1, 0);
    useEffect(() => {
    if (errorMsg) {
        forceUpdate(); // re-render so TextBoxLatest re-checks ref value
    }
    }, [errorMsg]);

    useEffect(() => {
        if (props?.value && ref?.current) {
            ref.current.value = props?.value;
        }
        console.log("refref", props?.value);
    }, [props.value]);

    const handleClick = () => {
        if (props.enableDateAutoPopup && fieldType === "DatePicker" && ref?.current) {
            try {
                ref.current.showPicker(); 
            } catch {
                ref.current.focus();
            }
        }
    };
    return (
        <div  onClick={handleClick} style={{ cursor: props.enableDateAutoPopup && fieldType === "DatePicker" ? "pointer" : "default" }}>
            <TextBoxLatest
                multiline={false}
                placeholder={fieldPlaceholder}
                title={fieldLabel}
                ref={ref}
                id={`${props.idNamespace ? props.idNamespace + '_' : ''}${id}`}
                isMandotary={isMandatory}
                type={fieldType === "DatePicker" ? "date" : "text"}
                isError={!!errorMsg}
                errorMsg={errorMsg}
                name={`${props.idNamespace ? props.idNamespace + '_' : ''}${id}`}
                InputProps={{
                    "readOnly": !props?.editable,
                }}
            />
            {/* {errorMsg && <FormHelperText>{errorMsg}</FormHelperText>} */}
            {(fieldDescription && fieldDescription.trim() !== "") && <FormHelperText className="helper-text-webform">{fieldDescription}</FormHelperText>}
        </div>
    );
};